import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const i = e((a, r) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: r,
    ...a,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...t,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M13 3a3 3 0 1 1 6 0v13.108c0 .835.926 1.253 1.457.608 1.358-1.646 2.477-3.884 2.477-5.716V8a2 2 0 0 1 4 0v3c0 4.18-3.067 8.951-6.634 11.131A2.72 2.72 0 0 0 19 24.45V31a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3.934a3 3 0 0 0-1.48-2.586l-.604-.356A12 12 0 0 1 5 13.78V9a2 2 0 1 1 4 0v4.78a8 8 0 0 0 2.55 5.857c.565.526 1.397.069 1.4-.703z"
          }
        )
      }
    )
  }
));
i.displayName = "OftenDryIcon";
export {
  i as OftenDryIcon,
  i as default
};
//# sourceMappingURL=index.js.map
